// src/services/api/pnlReport.js
import { apiClient } from './base';

/**
 * Get filter options for the P&L report (date range presets).
 * @returns {Promise<Object>} { dateRangePresets }
 */
export const getPnlFilters = async () => {
  const response = await apiClient.get('/reports/pnl/filters');
  return response.data;
};

/**
 * Get Profit & Loss report data.
 * @param {Object} params
 * @param {string} params.basis     - 'cash' | 'accrual'
 * @param {string} params.dateFrom  - YYYY-MM-DD
 * @param {string} params.dateTo    - YYYY-MM-DD
 * @param {string} params.groupBy   - 'none' | 'month' | 'quarter'
 * @returns {Promise<Object>} P&L data (summary or grouped)
 */
export const getPnlReport = async (params) => {
  const response = await apiClient.get('/reports/pnl', { params });
  return response.data;
};
